import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type PostOfficeGenericEmailDraftFragment = {
  __typename?: 'PostOfficeGenericEmailDraft';
  id: string;
  eventId: string;
  subject: string;
  replyToEmail: string;
  message: string;
  imageUrl?: string | null;
  includeAppInstructions: boolean;
  includeWebsiteDetails: boolean;
  includeEventPassword: boolean;
  personIds: Array<string>;
  salutation?: string | null;
  includeGuestNames: boolean;
};

export type PostOfficeReminderEmailDraftFragment = {
  __typename?: 'PostOfficeReminderEmailDraft';
  id: string;
  eventId: string;
  subject: string;
  replyToEmail: string;
  message: string;
  imageUrl?: string | null;
  includeAppInstructions: boolean;
  includeWebsiteDetails: boolean;
  includeEventPassword: boolean;
  personIds: Array<string>;
  salutation?: string | null;
  includeGuestNames: boolean;
};

export type PostOfficeThankYouEmailDraftFragment = {
  __typename?: 'PostOfficeThankYouEmailDraft';
  id: string;
  eventId: string;
  subject: string;
  replyToEmail: string;
  message: string;
  imageUrl?: string | null;
  personIds: Array<string>;
  personEmails?: Array<string> | null;
  assetId?: string | null;
  containerId?: string | null;
};

export type PostOfficeDraft_PostOfficeGenericEmailDraft_Fragment = {
  __typename?: 'PostOfficeGenericEmailDraft';
  id: string;
  eventId: string;
  subject: string;
  replyToEmail: string;
  message: string;
  imageUrl?: string | null;
  includeAppInstructions: boolean;
  includeWebsiteDetails: boolean;
  includeEventPassword: boolean;
  personIds: Array<string>;
  salutation?: string | null;
  includeGuestNames: boolean;
};

export type PostOfficeDraft_PostOfficeGiftWrapEmailDraft_Fragment = { __typename?: 'PostOfficeGiftWrapEmailDraft' };

export type PostOfficeDraft_PostOfficeGreetingCardEmailDraft_Fragment = { __typename?: 'PostOfficeGreetingCardEmailDraft' };

export type PostOfficeDraft_PostOfficeReminderEmailDraft_Fragment = {
  __typename?: 'PostOfficeReminderEmailDraft';
  id: string;
  eventId: string;
  subject: string;
  replyToEmail: string;
  message: string;
  imageUrl?: string | null;
  includeAppInstructions: boolean;
  includeWebsiteDetails: boolean;
  includeEventPassword: boolean;
  personIds: Array<string>;
  salutation?: string | null;
  includeGuestNames: boolean;
};

export type PostOfficeDraft_PostOfficeThankYouEmailDraft_Fragment = {
  __typename?: 'PostOfficeThankYouEmailDraft';
  id: string;
  eventId: string;
  subject: string;
  replyToEmail: string;
  message: string;
  imageUrl?: string | null;
  personIds: Array<string>;
  personEmails?: Array<string> | null;
  assetId?: string | null;
  containerId?: string | null;
};

export type PostOfficeDraftFragment =
  | PostOfficeDraft_PostOfficeGenericEmailDraft_Fragment
  | PostOfficeDraft_PostOfficeGiftWrapEmailDraft_Fragment
  | PostOfficeDraft_PostOfficeGreetingCardEmailDraft_Fragment
  | PostOfficeDraft_PostOfficeReminderEmailDraft_Fragment
  | PostOfficeDraft_PostOfficeThankYouEmailDraft_Fragment;

export type PostOfficeDraftByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type PostOfficeDraftByIdQuery = {
  __typename?: 'Query';
  getPostOfficeDraft?:
    | {
        __typename?: 'PostOfficeGenericEmailDraft';
        id: string;
        eventId: string;
        subject: string;
        replyToEmail: string;
        message: string;
        imageUrl?: string | null;
        includeAppInstructions: boolean;
        includeWebsiteDetails: boolean;
        includeEventPassword: boolean;
        personIds: Array<string>;
        salutation?: string | null;
        includeGuestNames: boolean;
      }
    | { __typename?: 'PostOfficeGiftWrapEmailDraft' }
    | { __typename?: 'PostOfficeGreetingCardEmailDraft' }
    | {
        __typename?: 'PostOfficeReminderEmailDraft';
        id: string;
        eventId: string;
        subject: string;
        replyToEmail: string;
        message: string;
        imageUrl?: string | null;
        includeAppInstructions: boolean;
        includeWebsiteDetails: boolean;
        includeEventPassword: boolean;
        personIds: Array<string>;
        salutation?: string | null;
        includeGuestNames: boolean;
      }
    | {
        __typename?: 'PostOfficeThankYouEmailDraft';
        id: string;
        eventId: string;
        subject: string;
        replyToEmail: string;
        message: string;
        imageUrl?: string | null;
        personIds: Array<string>;
        personEmails?: Array<string> | null;
        assetId?: string | null;
        containerId?: string | null;
      }
    | null;
};

export type PostOfficeDraftsByEventIdQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  messageType?: Types.InputMaybe<Types.PostOfficeMessageType>;
}>;

export type PostOfficeDraftsByEventIdQuery = {
  __typename?: 'Query';
  eventById?: {
    __typename?: 'Event';
    id: string;
    photoV2Url?: string | null;
    info: { __typename?: 'EventInfo'; id: string; eventPassword?: string | null; ownerFirstName?: string | null; fianceeFirstName?: string | null };
    photo?: { __typename?: 'Photo'; id: string; url: string } | null;
    settings: { __typename?: 'EventSettings'; id: string; privacyMode: Types.PrivacyModeType };
    pages: Array<{
      __typename?: 'EventPage';
      id: string;
      type: Types.EventPageType;
      pageSlug: string;
      pageTitle: string;
      disabled: boolean;
      private: boolean;
      visibility: Types.EventPageVisibility;
      isPageContainer: boolean;
      layoutType?: string | null;
      subTitle?: string | null;
      photoV2?:
        | {
            __typename?: 'DefaultPagePhoto';
            id: string;
            url: string;
            width: number;
            height: number;
            altTag?: string | null;
            layout: { __typename?: 'DefaultPagePhotoLayout'; alignX: string; alignY: string };
          }
        | {
            __typename?: 'Photo';
            id: string;
            url: string;
            width: number;
            height: number;
            altTag?: string | null;
            layout: { __typename?: 'PhotoLayout'; alignX: string; alignY: string };
            transform?: { __typename?: 'PhotoTransform'; x?: number | null; y?: number | null } | null;
          }
        | null;
      mobilePhoto?: {
        __typename?: 'Photo';
        id: string;
        url: string;
        width: number;
        height: number;
        altTag?: string | null;
        layout: { __typename?: 'PhotoLayout'; alignX: string; alignY: string };
        transform?: { __typename?: 'PhotoTransform'; x?: number | null; y?: number | null } | null;
      } | null;
      photoPresentation?: {
        __typename?: 'WebsitePagePhotoPresentation';
        id: string;
        presentationLayout: string;
        cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo'; x: number; y: number; width: number; height: number; unit: string } | null;
      } | null;
    }>;
  } | null;
  getPostOfficeDraftsByEventId: Array<
    | {
        __typename?: 'PostOfficeGenericEmailDraft';
        id: string;
        eventId: string;
        subject: string;
        replyToEmail: string;
        message: string;
        imageUrl?: string | null;
        includeAppInstructions: boolean;
        includeWebsiteDetails: boolean;
        includeEventPassword: boolean;
        personIds: Array<string>;
        salutation?: string | null;
        includeGuestNames: boolean;
      }
    | { __typename?: 'PostOfficeGiftWrapEmailDraft' }
    | { __typename?: 'PostOfficeGreetingCardEmailDraft' }
    | {
        __typename?: 'PostOfficeReminderEmailDraft';
        id: string;
        eventId: string;
        subject: string;
        replyToEmail: string;
        message: string;
        imageUrl?: string | null;
        includeAppInstructions: boolean;
        includeWebsiteDetails: boolean;
        includeEventPassword: boolean;
        personIds: Array<string>;
        salutation?: string | null;
        includeGuestNames: boolean;
      }
    | {
        __typename?: 'PostOfficeThankYouEmailDraft';
        id: string;
        eventId: string;
        subject: string;
        replyToEmail: string;
        message: string;
        imageUrl?: string | null;
        personIds: Array<string>;
        personEmails?: Array<string> | null;
        assetId?: string | null;
        containerId?: string | null;
      }
  >;
};

export type SavePostOfficeGenericEmailDraftMutationVariables = Types.Exact<{
  imageUrl?: Types.InputMaybe<Types.Scalars['String']>;
  draftId?: Types.InputMaybe<Types.Scalars['ID']>;
  eventId: Types.Scalars['ID'];
  subject: Types.Scalars['String'];
  replyToEmail: Types.Scalars['String'];
  message: Types.Scalars['String'];
  includeAppInstructions: Types.Scalars['Boolean'];
  includeWebsiteDetails: Types.Scalars['Boolean'];
  includeEventPassword: Types.Scalars['Boolean'];
  personIds: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
  salutation?: Types.InputMaybe<Types.Scalars['String']>;
  includeGuestNames: Types.Scalars['Boolean'];
}>;

export type SavePostOfficeGenericEmailDraftMutation = {
  __typename?: 'Mutation';
  savePostOfficeGenericEmailDraft: {
    __typename?: 'PostOfficeGenericEmailDraft';
    id: string;
    eventId: string;
    subject: string;
    replyToEmail: string;
    message: string;
    imageUrl?: string | null;
    includeAppInstructions: boolean;
    includeWebsiteDetails: boolean;
    includeEventPassword: boolean;
    personIds: Array<string>;
    salutation?: string | null;
    includeGuestNames: boolean;
  };
};

export type SendPostOfficeGenericEmailMutationVariables = Types.Exact<{
  imageUrl?: Types.InputMaybe<Types.Scalars['String']>;
  eventId: Types.Scalars['ID'];
  subject: Types.Scalars['String'];
  replyToEmail: Types.Scalars['String'];
  message: Types.Scalars['String'];
  includeAppInstructions: Types.Scalars['Boolean'];
  includeWebsiteDetails: Types.Scalars['Boolean'];
  includeEventPassword: Types.Scalars['Boolean'];
  personIds: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
  testName?: Types.InputMaybe<Types.Scalars['String']>;
  testEmail?: Types.InputMaybe<Types.Scalars['String']>;
  footerText?: Types.InputMaybe<Types.Scalars['String']>;
  salutation?: Types.InputMaybe<Types.Scalars['String']>;
  includeGuestNames: Types.Scalars['Boolean'];
}>;

export type SendPostOfficeGenericEmailMutation = { __typename?: 'Mutation'; sendPostOfficeGenericEmail?: any | null };

export type SavePostOfficeReminderEmailDraftMutationVariables = Types.Exact<{
  imageUrl?: Types.InputMaybe<Types.Scalars['String']>;
  draftId?: Types.InputMaybe<Types.Scalars['ID']>;
  eventId: Types.Scalars['ID'];
  subject: Types.Scalars['String'];
  replyToEmail: Types.Scalars['String'];
  message: Types.Scalars['String'];
  includeAppInstructions: Types.Scalars['Boolean'];
  includeWebsiteDetails: Types.Scalars['Boolean'];
  includeEventPassword: Types.Scalars['Boolean'];
  personIds: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
  salutation?: Types.InputMaybe<Types.Scalars['String']>;
  includeGuestNames: Types.Scalars['Boolean'];
}>;

export type SavePostOfficeReminderEmailDraftMutation = {
  __typename?: 'Mutation';
  savePostOfficeReminderEmailDraft: {
    __typename?: 'PostOfficeReminderEmailDraft';
    id: string;
    eventId: string;
    subject: string;
    replyToEmail: string;
    message: string;
    imageUrl?: string | null;
    includeAppInstructions: boolean;
    includeWebsiteDetails: boolean;
    includeEventPassword: boolean;
    personIds: Array<string>;
    salutation?: string | null;
    includeGuestNames: boolean;
  };
};

export type SendPostOfficeReminderEmailMutationVariables = Types.Exact<{
  imageUrl?: Types.InputMaybe<Types.Scalars['String']>;
  eventId: Types.Scalars['ID'];
  subject: Types.Scalars['String'];
  replyToEmail: Types.Scalars['String'];
  message: Types.Scalars['String'];
  includeAppInstructions: Types.Scalars['Boolean'];
  includeWebsiteDetails: Types.Scalars['Boolean'];
  includeEventPassword: Types.Scalars['Boolean'];
  personIds: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
  testName?: Types.InputMaybe<Types.Scalars['String']>;
  testEmail?: Types.InputMaybe<Types.Scalars['String']>;
  footerText?: Types.InputMaybe<Types.Scalars['String']>;
  salutation?: Types.InputMaybe<Types.Scalars['String']>;
  includeGuestNames: Types.Scalars['Boolean'];
}>;

export type SendPostOfficeReminderEmailMutation = { __typename?: 'Mutation'; sendPostOfficeReminderEmail?: any | null };

export type SavePostOfficeThankYouEmailDraftMutationVariables = Types.Exact<{
  imageUrl?: Types.InputMaybe<Types.Scalars['String']>;
  draftId?: Types.InputMaybe<Types.Scalars['ID']>;
  eventId: Types.Scalars['ID'];
  subject: Types.Scalars['String'];
  replyToEmail: Types.Scalars['String'];
  message: Types.Scalars['String'];
  personIds?: Types.InputMaybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>;
  personEmails?: Types.InputMaybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
  assetId?: Types.InputMaybe<Types.Scalars['String']>;
  containerId?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type SavePostOfficeThankYouEmailDraftMutation = {
  __typename?: 'Mutation';
  savePostOfficeThankYouEmailDraft: {
    __typename?: 'PostOfficeThankYouEmailDraft';
    id: string;
    eventId: string;
    subject: string;
    replyToEmail: string;
    message: string;
    imageUrl?: string | null;
    personIds: Array<string>;
    personEmails?: Array<string> | null;
    assetId?: string | null;
    containerId?: string | null;
  };
};

export type SendPostOfficeThankYouEmailMutationVariables = Types.Exact<{
  imageUrl?: Types.InputMaybe<Types.Scalars['String']>;
  eventId: Types.Scalars['ID'];
  subject: Types.Scalars['String'];
  replyToEmail: Types.Scalars['String'];
  message: Types.Scalars['String'];
  personIds?: Types.InputMaybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>;
  personEmails?: Types.InputMaybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
  testName?: Types.InputMaybe<Types.Scalars['String']>;
  testEmail?: Types.InputMaybe<Types.Scalars['String']>;
  relation?: Types.InputMaybe<Types.EmailRelationInput>;
  footerText?: Types.InputMaybe<Types.Scalars['String']>;
  assetId?: Types.InputMaybe<Types.Scalars['String']>;
  containerId?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type SendPostOfficeThankYouEmailMutation = { __typename?: 'Mutation'; sendPostOfficeThankYouEmail?: any | null };

export type ChatGPTTextCompletionQueryVariables = Types.Exact<{
  prompt: Types.Scalars['String'];
  modelVersion?: Types.InputMaybe<Types.AiModelVersion>;
}>;

export type ChatGPTTextCompletionQuery = { __typename?: 'Query'; textCompletion: string };

export const PostOfficeGenericEmailDraftFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PostOfficeGenericEmailDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostOfficeGenericEmailDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'replyToEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAppInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeWebsiteDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeEventPassword' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salutation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeGuestNames' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const PostOfficeReminderEmailDraftFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PostOfficeReminderEmailDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostOfficeReminderEmailDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'replyToEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAppInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeWebsiteDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeEventPassword' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salutation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeGuestNames' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const PostOfficeThankYouEmailDraftFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PostOfficeThankYouEmailDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostOfficeThankYouEmailDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'replyToEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personEmails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assetId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'containerId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const PostOfficeDraftFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PostOfficeDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostOfficeDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PostOfficeGenericEmailDraft' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PostOfficeReminderEmailDraft' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PostOfficeThankYouEmailDraft' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PostOfficeGenericEmailDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostOfficeGenericEmailDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'replyToEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAppInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeWebsiteDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeEventPassword' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salutation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeGuestNames' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PostOfficeReminderEmailDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostOfficeReminderEmailDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'replyToEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAppInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeWebsiteDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeEventPassword' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salutation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeGuestNames' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PostOfficeThankYouEmailDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostOfficeThankYouEmailDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'replyToEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personEmails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assetId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'containerId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const PostOfficeDraftByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PostOfficeDraftById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getPostOfficeDraft' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PostOfficeDraft' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PostOfficeGenericEmailDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostOfficeGenericEmailDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'replyToEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAppInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeWebsiteDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeEventPassword' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salutation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeGuestNames' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PostOfficeReminderEmailDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostOfficeReminderEmailDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'replyToEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAppInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeWebsiteDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeEventPassword' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salutation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeGuestNames' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PostOfficeThankYouEmailDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostOfficeThankYouEmailDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'replyToEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personEmails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assetId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'containerId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PostOfficeDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostOfficeDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PostOfficeGenericEmailDraft' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PostOfficeReminderEmailDraft' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PostOfficeThankYouEmailDraft' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePostOfficeDraftByIdQuery__
 *
 * To run a query within a React component, call `usePostOfficeDraftByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostOfficeDraftByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostOfficeDraftByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostOfficeDraftByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PostOfficeDraftByIdQuery, PostOfficeDraftByIdQueryVariables>) {
  return ApolloReactHooks.useQuery<PostOfficeDraftByIdQuery, PostOfficeDraftByIdQueryVariables>(PostOfficeDraftByIdDocument, baseOptions);
}
export function usePostOfficeDraftByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PostOfficeDraftByIdQuery, PostOfficeDraftByIdQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<PostOfficeDraftByIdQuery, PostOfficeDraftByIdQueryVariables>(PostOfficeDraftByIdDocument, baseOptions);
}
export type PostOfficeDraftByIdQueryHookResult = ReturnType<typeof usePostOfficeDraftByIdQuery>;
export type PostOfficeDraftByIdLazyQueryHookResult = ReturnType<typeof usePostOfficeDraftByIdLazyQuery>;
export type PostOfficeDraftByIdQueryResult = Apollo.QueryResult<PostOfficeDraftByIdQuery, PostOfficeDraftByIdQueryVariables>;
export const PostOfficeDraftsByEventIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PostOfficeDraftsByEventId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PostOfficeMessageType' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventPassword' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'photoV2Url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'privacyMode' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pages' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventPage' } }] },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getPostOfficeDraftsByEventId' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'messageType' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'messageType' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PostOfficeDraft' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PostOfficeGenericEmailDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostOfficeGenericEmailDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'replyToEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAppInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeWebsiteDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeEventPassword' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salutation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeGuestNames' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PostOfficeReminderEmailDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostOfficeReminderEmailDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'replyToEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAppInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeWebsiteDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeEventPassword' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salutation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeGuestNames' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PostOfficeThankYouEmailDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostOfficeThankYouEmailDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'replyToEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personEmails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assetId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'containerId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PostOfficeDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostOfficeDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PostOfficeGenericEmailDraft' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PostOfficeReminderEmailDraft' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PostOfficeThankYouEmailDraft' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventPage' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventPage' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSlug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageTitle' } },
          { kind: 'Field', alias: { kind: 'Name', value: 'subTitle' }, name: { kind: 'Name', value: 'pageSubTitleV0918' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'private' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPageContainer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'layoutType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoV2' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoV2WithoutBlurHash' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobilePhoto' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoWithoutBlurHash' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoPresentation' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'WebsitePagePhotoPresentation' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoV2WithoutBlurHash' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PagePhoto' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'altTag' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'layout' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoLayout' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transform' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoTransform' } }] },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DefaultPagePhoto' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'altTag' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'layout' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoLayoutV2' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoLayout' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhotoLayout' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoTransform' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhotoTransform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoLayoutV2' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DefaultPagePhotoLayout' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoWithoutBlurHash' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'altTag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoLayout' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transform' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoTransform' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsitePagePhotoPresentation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsitePagePhotoPresentation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'presentationLayout' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cropInfo' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'WebsitePagePhotoPresentationCropInfo' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsitePagePhotoPresentationCropInfo' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsitePagePhotoPresentationCropInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePostOfficeDraftsByEventIdQuery__
 *
 * To run a query within a React component, call `usePostOfficeDraftsByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostOfficeDraftsByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostOfficeDraftsByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      messageType: // value for 'messageType'
 *   },
 * });
 */
export function usePostOfficeDraftsByEventIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PostOfficeDraftsByEventIdQuery, PostOfficeDraftsByEventIdQueryVariables>) {
  return ApolloReactHooks.useQuery<PostOfficeDraftsByEventIdQuery, PostOfficeDraftsByEventIdQueryVariables>(PostOfficeDraftsByEventIdDocument, baseOptions);
}
export function usePostOfficeDraftsByEventIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PostOfficeDraftsByEventIdQuery, PostOfficeDraftsByEventIdQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<PostOfficeDraftsByEventIdQuery, PostOfficeDraftsByEventIdQueryVariables>(PostOfficeDraftsByEventIdDocument, baseOptions);
}
export type PostOfficeDraftsByEventIdQueryHookResult = ReturnType<typeof usePostOfficeDraftsByEventIdQuery>;
export type PostOfficeDraftsByEventIdLazyQueryHookResult = ReturnType<typeof usePostOfficeDraftsByEventIdLazyQuery>;
export type PostOfficeDraftsByEventIdQueryResult = Apollo.QueryResult<PostOfficeDraftsByEventIdQuery, PostOfficeDraftsByEventIdQueryVariables>;
export const SavePostOfficeGenericEmailDraftDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SavePostOfficeGenericEmailDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'imageUrl' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'draftId' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'replyToEmail' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'message' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeAppInstructions' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeWebsiteDetails' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeEventPassword' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'personIds' } },
          type: { kind: 'NonNullType', type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'salutation' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeGuestNames' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'savePostOfficeGenericEmailDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'payload' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'draftId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'draftId' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'subject' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'replyToEmail' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'replyToEmail' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'message' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'message' } } },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'includeAppInstructions' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'includeAppInstructions' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'includeWebsiteDetails' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'includeWebsiteDetails' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'includeEventPassword' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'includeEventPassword' } },
                    },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'personIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'personIds' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'salutation' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'salutation' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'includeGuestNames' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeGuestNames' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'imageUrl' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'imageUrl' } } },
                  ],
                },
              },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PostOfficeGenericEmailDraft' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PostOfficeGenericEmailDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostOfficeGenericEmailDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'replyToEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAppInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeWebsiteDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeEventPassword' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salutation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeGuestNames' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SavePostOfficeGenericEmailDraftMutationFn = Apollo.MutationFunction<SavePostOfficeGenericEmailDraftMutation, SavePostOfficeGenericEmailDraftMutationVariables>;

/**
 * __useSavePostOfficeGenericEmailDraftMutation__
 *
 * To run a mutation, you first call `useSavePostOfficeGenericEmailDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePostOfficeGenericEmailDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePostOfficeGenericEmailDraftMutation, { data, loading, error }] = useSavePostOfficeGenericEmailDraftMutation({
 *   variables: {
 *      imageUrl: // value for 'imageUrl'
 *      draftId: // value for 'draftId'
 *      eventId: // value for 'eventId'
 *      subject: // value for 'subject'
 *      replyToEmail: // value for 'replyToEmail'
 *      message: // value for 'message'
 *      includeAppInstructions: // value for 'includeAppInstructions'
 *      includeWebsiteDetails: // value for 'includeWebsiteDetails'
 *      includeEventPassword: // value for 'includeEventPassword'
 *      personIds: // value for 'personIds'
 *      salutation: // value for 'salutation'
 *      includeGuestNames: // value for 'includeGuestNames'
 *   },
 * });
 */
export function useSavePostOfficeGenericEmailDraftMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<SavePostOfficeGenericEmailDraftMutation, SavePostOfficeGenericEmailDraftMutationVariables>,
) {
  return ApolloReactHooks.useMutation<SavePostOfficeGenericEmailDraftMutation, SavePostOfficeGenericEmailDraftMutationVariables>(
    SavePostOfficeGenericEmailDraftDocument,
    baseOptions,
  );
}
export type SavePostOfficeGenericEmailDraftMutationHookResult = ReturnType<typeof useSavePostOfficeGenericEmailDraftMutation>;
export type SavePostOfficeGenericEmailDraftMutationResult = Apollo.MutationResult<SavePostOfficeGenericEmailDraftMutation>;
export type SavePostOfficeGenericEmailDraftMutationOptions = Apollo.BaseMutationOptions<SavePostOfficeGenericEmailDraftMutation, SavePostOfficeGenericEmailDraftMutationVariables>;
export const SendPostOfficeGenericEmailDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendPostOfficeGenericEmail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'imageUrl' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'replyToEmail' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'message' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeAppInstructions' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeWebsiteDetails' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeEventPassword' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'personIds' } },
          type: { kind: 'NonNullType', type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'testName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'testEmail' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'footerText' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'salutation' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeGuestNames' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendPostOfficeGenericEmail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'payload' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'subject' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'replyToEmail' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'replyToEmail' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'message' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'message' } } },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'includeAppInstructions' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'includeAppInstructions' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'includeWebsiteDetails' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'includeWebsiteDetails' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'includeEventPassword' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'includeEventPassword' } },
                    },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'personIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'personIds' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'testName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'testName' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'testEmail' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'testEmail' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'footerText' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'footerText' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'salutation' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'salutation' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'includeGuestNames' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeGuestNames' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'imageUrl' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'imageUrl' } } },
                  ],
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SendPostOfficeGenericEmailMutationFn = Apollo.MutationFunction<SendPostOfficeGenericEmailMutation, SendPostOfficeGenericEmailMutationVariables>;

/**
 * __useSendPostOfficeGenericEmailMutation__
 *
 * To run a mutation, you first call `useSendPostOfficeGenericEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPostOfficeGenericEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPostOfficeGenericEmailMutation, { data, loading, error }] = useSendPostOfficeGenericEmailMutation({
 *   variables: {
 *      imageUrl: // value for 'imageUrl'
 *      eventId: // value for 'eventId'
 *      subject: // value for 'subject'
 *      replyToEmail: // value for 'replyToEmail'
 *      message: // value for 'message'
 *      includeAppInstructions: // value for 'includeAppInstructions'
 *      includeWebsiteDetails: // value for 'includeWebsiteDetails'
 *      includeEventPassword: // value for 'includeEventPassword'
 *      personIds: // value for 'personIds'
 *      testName: // value for 'testName'
 *      testEmail: // value for 'testEmail'
 *      footerText: // value for 'footerText'
 *      salutation: // value for 'salutation'
 *      includeGuestNames: // value for 'includeGuestNames'
 *   },
 * });
 */
export function useSendPostOfficeGenericEmailMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<SendPostOfficeGenericEmailMutation, SendPostOfficeGenericEmailMutationVariables>,
) {
  return ApolloReactHooks.useMutation<SendPostOfficeGenericEmailMutation, SendPostOfficeGenericEmailMutationVariables>(SendPostOfficeGenericEmailDocument, baseOptions);
}
export type SendPostOfficeGenericEmailMutationHookResult = ReturnType<typeof useSendPostOfficeGenericEmailMutation>;
export type SendPostOfficeGenericEmailMutationResult = Apollo.MutationResult<SendPostOfficeGenericEmailMutation>;
export type SendPostOfficeGenericEmailMutationOptions = Apollo.BaseMutationOptions<SendPostOfficeGenericEmailMutation, SendPostOfficeGenericEmailMutationVariables>;
export const SavePostOfficeReminderEmailDraftDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SavePostOfficeReminderEmailDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'imageUrl' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'draftId' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'replyToEmail' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'message' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeAppInstructions' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeWebsiteDetails' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeEventPassword' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'personIds' } },
          type: { kind: 'NonNullType', type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'salutation' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeGuestNames' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'savePostOfficeReminderEmailDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'payload' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'draftId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'draftId' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'subject' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'replyToEmail' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'replyToEmail' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'message' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'message' } } },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'includeAppInstructions' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'includeAppInstructions' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'includeWebsiteDetails' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'includeWebsiteDetails' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'includeEventPassword' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'includeEventPassword' } },
                    },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'personIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'personIds' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'salutation' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'salutation' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'includeGuestNames' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeGuestNames' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'imageUrl' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'imageUrl' } } },
                  ],
                },
              },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PostOfficeReminderEmailDraft' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PostOfficeReminderEmailDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostOfficeReminderEmailDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'replyToEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAppInstructions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeWebsiteDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeEventPassword' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salutation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeGuestNames' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SavePostOfficeReminderEmailDraftMutationFn = Apollo.MutationFunction<SavePostOfficeReminderEmailDraftMutation, SavePostOfficeReminderEmailDraftMutationVariables>;

/**
 * __useSavePostOfficeReminderEmailDraftMutation__
 *
 * To run a mutation, you first call `useSavePostOfficeReminderEmailDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePostOfficeReminderEmailDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePostOfficeReminderEmailDraftMutation, { data, loading, error }] = useSavePostOfficeReminderEmailDraftMutation({
 *   variables: {
 *      imageUrl: // value for 'imageUrl'
 *      draftId: // value for 'draftId'
 *      eventId: // value for 'eventId'
 *      subject: // value for 'subject'
 *      replyToEmail: // value for 'replyToEmail'
 *      message: // value for 'message'
 *      includeAppInstructions: // value for 'includeAppInstructions'
 *      includeWebsiteDetails: // value for 'includeWebsiteDetails'
 *      includeEventPassword: // value for 'includeEventPassword'
 *      personIds: // value for 'personIds'
 *      salutation: // value for 'salutation'
 *      includeGuestNames: // value for 'includeGuestNames'
 *   },
 * });
 */
export function useSavePostOfficeReminderEmailDraftMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<SavePostOfficeReminderEmailDraftMutation, SavePostOfficeReminderEmailDraftMutationVariables>,
) {
  return ApolloReactHooks.useMutation<SavePostOfficeReminderEmailDraftMutation, SavePostOfficeReminderEmailDraftMutationVariables>(
    SavePostOfficeReminderEmailDraftDocument,
    baseOptions,
  );
}
export type SavePostOfficeReminderEmailDraftMutationHookResult = ReturnType<typeof useSavePostOfficeReminderEmailDraftMutation>;
export type SavePostOfficeReminderEmailDraftMutationResult = Apollo.MutationResult<SavePostOfficeReminderEmailDraftMutation>;
export type SavePostOfficeReminderEmailDraftMutationOptions = Apollo.BaseMutationOptions<
  SavePostOfficeReminderEmailDraftMutation,
  SavePostOfficeReminderEmailDraftMutationVariables
>;
export const SendPostOfficeReminderEmailDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendPostOfficeReminderEmail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'imageUrl' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'replyToEmail' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'message' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeAppInstructions' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeWebsiteDetails' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeEventPassword' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'personIds' } },
          type: { kind: 'NonNullType', type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'testName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'testEmail' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'footerText' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'salutation' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeGuestNames' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendPostOfficeReminderEmail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'payload' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'subject' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'replyToEmail' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'replyToEmail' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'message' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'message' } } },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'includeAppInstructions' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'includeAppInstructions' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'includeWebsiteDetails' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'includeWebsiteDetails' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'includeEventPassword' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'includeEventPassword' } },
                    },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'personIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'personIds' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'testName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'testName' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'testEmail' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'testEmail' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'footerText' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'footerText' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'salutation' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'salutation' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'includeGuestNames' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeGuestNames' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'imageUrl' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'imageUrl' } } },
                  ],
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SendPostOfficeReminderEmailMutationFn = Apollo.MutationFunction<SendPostOfficeReminderEmailMutation, SendPostOfficeReminderEmailMutationVariables>;

/**
 * __useSendPostOfficeReminderEmailMutation__
 *
 * To run a mutation, you first call `useSendPostOfficeReminderEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPostOfficeReminderEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPostOfficeReminderEmailMutation, { data, loading, error }] = useSendPostOfficeReminderEmailMutation({
 *   variables: {
 *      imageUrl: // value for 'imageUrl'
 *      eventId: // value for 'eventId'
 *      subject: // value for 'subject'
 *      replyToEmail: // value for 'replyToEmail'
 *      message: // value for 'message'
 *      includeAppInstructions: // value for 'includeAppInstructions'
 *      includeWebsiteDetails: // value for 'includeWebsiteDetails'
 *      includeEventPassword: // value for 'includeEventPassword'
 *      personIds: // value for 'personIds'
 *      testName: // value for 'testName'
 *      testEmail: // value for 'testEmail'
 *      footerText: // value for 'footerText'
 *      salutation: // value for 'salutation'
 *      includeGuestNames: // value for 'includeGuestNames'
 *   },
 * });
 */
export function useSendPostOfficeReminderEmailMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<SendPostOfficeReminderEmailMutation, SendPostOfficeReminderEmailMutationVariables>,
) {
  return ApolloReactHooks.useMutation<SendPostOfficeReminderEmailMutation, SendPostOfficeReminderEmailMutationVariables>(SendPostOfficeReminderEmailDocument, baseOptions);
}
export type SendPostOfficeReminderEmailMutationHookResult = ReturnType<typeof useSendPostOfficeReminderEmailMutation>;
export type SendPostOfficeReminderEmailMutationResult = Apollo.MutationResult<SendPostOfficeReminderEmailMutation>;
export type SendPostOfficeReminderEmailMutationOptions = Apollo.BaseMutationOptions<SendPostOfficeReminderEmailMutation, SendPostOfficeReminderEmailMutationVariables>;
export const SavePostOfficeThankYouEmailDraftDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SavePostOfficeThankYouEmailDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'imageUrl' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'draftId' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'replyToEmail' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'message' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'personIds' } },
          type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'personEmails' } },
          type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assetId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'containerId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'savePostOfficeThankYouEmailDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'payload' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'draftId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'draftId' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'subject' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'replyToEmail' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'replyToEmail' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'message' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'message' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'personIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'personIds' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'personEmails' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'personEmails' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'imageUrl' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'imageUrl' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'assetId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'assetId' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'containerId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'containerId' } } },
                  ],
                },
              },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PostOfficeThankYouEmailDraft' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PostOfficeThankYouEmailDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PostOfficeThankYouEmailDraft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'replyToEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personIds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personEmails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assetId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'containerId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SavePostOfficeThankYouEmailDraftMutationFn = Apollo.MutationFunction<SavePostOfficeThankYouEmailDraftMutation, SavePostOfficeThankYouEmailDraftMutationVariables>;

/**
 * __useSavePostOfficeThankYouEmailDraftMutation__
 *
 * To run a mutation, you first call `useSavePostOfficeThankYouEmailDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePostOfficeThankYouEmailDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePostOfficeThankYouEmailDraftMutation, { data, loading, error }] = useSavePostOfficeThankYouEmailDraftMutation({
 *   variables: {
 *      imageUrl: // value for 'imageUrl'
 *      draftId: // value for 'draftId'
 *      eventId: // value for 'eventId'
 *      subject: // value for 'subject'
 *      replyToEmail: // value for 'replyToEmail'
 *      message: // value for 'message'
 *      personIds: // value for 'personIds'
 *      personEmails: // value for 'personEmails'
 *      assetId: // value for 'assetId'
 *      containerId: // value for 'containerId'
 *   },
 * });
 */
export function useSavePostOfficeThankYouEmailDraftMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<SavePostOfficeThankYouEmailDraftMutation, SavePostOfficeThankYouEmailDraftMutationVariables>,
) {
  return ApolloReactHooks.useMutation<SavePostOfficeThankYouEmailDraftMutation, SavePostOfficeThankYouEmailDraftMutationVariables>(
    SavePostOfficeThankYouEmailDraftDocument,
    baseOptions,
  );
}
export type SavePostOfficeThankYouEmailDraftMutationHookResult = ReturnType<typeof useSavePostOfficeThankYouEmailDraftMutation>;
export type SavePostOfficeThankYouEmailDraftMutationResult = Apollo.MutationResult<SavePostOfficeThankYouEmailDraftMutation>;
export type SavePostOfficeThankYouEmailDraftMutationOptions = Apollo.BaseMutationOptions<
  SavePostOfficeThankYouEmailDraftMutation,
  SavePostOfficeThankYouEmailDraftMutationVariables
>;
export const SendPostOfficeThankYouEmailDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendPostOfficeThankYouEmail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'imageUrl' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'replyToEmail' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'message' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'personIds' } },
          type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'personEmails' } },
          type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'testName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'testEmail' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'relation' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EmailRelationInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'footerText' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assetId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'containerId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendPostOfficeThankYouEmail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'payload' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'subject' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'replyToEmail' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'replyToEmail' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'message' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'message' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'personIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'personIds' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'personEmails' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'personEmails' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'testName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'testName' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'testEmail' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'testEmail' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'imageUrl' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'imageUrl' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'footerText' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'footerText' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'assetId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'assetId' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'containerId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'containerId' } } },
                  ],
                },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'relation' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'relation' } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SendPostOfficeThankYouEmailMutationFn = Apollo.MutationFunction<SendPostOfficeThankYouEmailMutation, SendPostOfficeThankYouEmailMutationVariables>;

/**
 * __useSendPostOfficeThankYouEmailMutation__
 *
 * To run a mutation, you first call `useSendPostOfficeThankYouEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPostOfficeThankYouEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPostOfficeThankYouEmailMutation, { data, loading, error }] = useSendPostOfficeThankYouEmailMutation({
 *   variables: {
 *      imageUrl: // value for 'imageUrl'
 *      eventId: // value for 'eventId'
 *      subject: // value for 'subject'
 *      replyToEmail: // value for 'replyToEmail'
 *      message: // value for 'message'
 *      personIds: // value for 'personIds'
 *      personEmails: // value for 'personEmails'
 *      testName: // value for 'testName'
 *      testEmail: // value for 'testEmail'
 *      relation: // value for 'relation'
 *      footerText: // value for 'footerText'
 *      assetId: // value for 'assetId'
 *      containerId: // value for 'containerId'
 *   },
 * });
 */
export function useSendPostOfficeThankYouEmailMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<SendPostOfficeThankYouEmailMutation, SendPostOfficeThankYouEmailMutationVariables>,
) {
  return ApolloReactHooks.useMutation<SendPostOfficeThankYouEmailMutation, SendPostOfficeThankYouEmailMutationVariables>(SendPostOfficeThankYouEmailDocument, baseOptions);
}
export type SendPostOfficeThankYouEmailMutationHookResult = ReturnType<typeof useSendPostOfficeThankYouEmailMutation>;
export type SendPostOfficeThankYouEmailMutationResult = Apollo.MutationResult<SendPostOfficeThankYouEmailMutation>;
export type SendPostOfficeThankYouEmailMutationOptions = Apollo.BaseMutationOptions<SendPostOfficeThankYouEmailMutation, SendPostOfficeThankYouEmailMutationVariables>;
export const ChatGPTTextCompletionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ChatGPTTextCompletion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'prompt' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'modelVersion' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AiModelVersion' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textCompletion' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'prompt' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'prompt' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'modelVersion' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'modelVersion' } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useChatGPTTextCompletionQuery__
 *
 * To run a query within a React component, call `useChatGPTTextCompletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatGPTTextCompletionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatGPTTextCompletionQuery({
 *   variables: {
 *      prompt: // value for 'prompt'
 *      modelVersion: // value for 'modelVersion'
 *   },
 * });
 */
export function useChatGPTTextCompletionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChatGPTTextCompletionQuery, ChatGPTTextCompletionQueryVariables>) {
  return ApolloReactHooks.useQuery<ChatGPTTextCompletionQuery, ChatGPTTextCompletionQueryVariables>(ChatGPTTextCompletionDocument, baseOptions);
}
export function useChatGPTTextCompletionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChatGPTTextCompletionQuery, ChatGPTTextCompletionQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<ChatGPTTextCompletionQuery, ChatGPTTextCompletionQueryVariables>(ChatGPTTextCompletionDocument, baseOptions);
}
export type ChatGPTTextCompletionQueryHookResult = ReturnType<typeof useChatGPTTextCompletionQuery>;
export type ChatGPTTextCompletionLazyQueryHookResult = ReturnType<typeof useChatGPTTextCompletionLazyQuery>;
export type ChatGPTTextCompletionQueryResult = Apollo.QueryResult<ChatGPTTextCompletionQuery, ChatGPTTextCompletionQueryVariables>;
